export const DEVICE_TYPES = {
  MOBILE: 'Mobile',
  WEB: 'Web',
};

export const RESPONSE_CODES = {
  SUCCESS: 200,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  TOO_MANY_REQUESTS: 429,
  NOT_FOUND: 404,
  INTERNAL_SERVER_ERROR: 500,
};

export const TFA_INCORRECT_CODE_KEY = 'profile.errorMessages.incorrectCode';
export const TFA_MISSING_TOKEN_KEY = 'profile.errorMessages.twoFactorUnavailable';
export const TFA_CANCELLED_KEY = 'profile.errorMessages.twoFactorCancelled';

export const TFA_ERROR_MESSAGE_KEYS: Record<number, string> = {
  [RESPONSE_CODES.UNAUTHORIZED]: 'profile.errorMessages.twoFactorSessionExpired',
  [RESPONSE_CODES.FORBIDDEN]: 'profile.errorMessages.twoFactorAccountLocked',
  [RESPONSE_CODES.TOO_MANY_REQUESTS]: 'profile.errorMessages.twoFactorTooManyAttempts',
};
